import React, { Component, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import FindPassByPhone from './FindPassByPhone'
import FindPassByEmail from './FindPassByEmail'
import Alert from '../../../module/alert/'
import Header from '../../../layout/default/Header'
import { commons } from '../../../hook/common'
import $ from 'jquery'

/* class FindPass extends Component {
	constructor(props) {
		super(props)

		this.state = {
			type: 'sms'
		}
	} */
const FindPass = (props) => {
  const [state, setState] = useState({ type: 'sms' })

  const handleTab = (type) => {
    setState({
      ...state,
      type: type,
    })
  }

  useEffect(() => {
    $('#list li').on('click', function () {
      $('#findPhone').removeClass('on')
      $('#findPhone').text($(this).text())
    })
  }, [])

  return (
    <React.Fragment>
      <Alert />
      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header type2">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
              className="page-prev"
            >
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            <h2>비밀번호 찾기</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <em>비밀번호 찾기</em>
            </div>
          </div>
          <div className="login-wrap">
            <ul className="nav-tab w124 tabs">
              <li className="on">
                {/* <input id="id-find-1" type="radio" name="tab" defaultChecked={true} onChange={() => this.handleTab('sms')}/> */}
                <a href="#pw-tab1" onClick={() => handleTab('sms')}>
                  휴대폰으로 찾기
                </a>
                {/* <a href="#pw-tab1">휴대폰으로 찾기</a> */}
              </li>
              <li>
                {/* <a href="#pw-tab2">이메일로 찾기</a> */}
                <a href="#pw-tab2" onClick={() => handleTab('email')}>
                  이메일로 찾기
                </a>
              </li>
            </ul>
            {/*  <!-- mobile --> */}
            <div className="nav-wrap">
              <a href="#" id="findPhone" className="current-menu">
                휴대폰으로 찾기
              </a>
              <ul className="nav-menu" id="list">
                <li>
                  <a href="#" onClick={() => handleTab('sms')}>
                    휴대폰으로 찾기
                  </a>
                </li>
                <li>
                  <a href="#" onClick={() => handleTab('email')}>
                    이메일로 찾기
                  </a>
                </li>
              </ul>
            </div>
            {/*  <!-- //mobile --> */}
            <div className="tab-container">
              <div id="pw-tab1" className="tab-cont">
                {state.type === 'sms' ? <FindPassByPhone /> : ''}
              </div>
              <div id="pw-tab2" className="tab-cont">
                {state.type === 'email' ? <FindPassByEmail /> : ''}
              </div>
            </div>
          </div>
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
    </React.Fragment>
  )
}

export default FindPass
